import MiddlePanel from 'Components/MiddlePanel/MiddlePanel';
import Panel from 'Components/Panel/Panel';
import { useEffect, useState } from 'react';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import InputField from 'Components/Input/InputField';
import LocalTimeFromInstant from 'Components/LocalTimeFromInstant/LocalTimeFromInstant';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import ReactDataPickerComp from 'Components/ReactDataPicker/ReactDataPickerComp';
import MandatoryIconField from 'Components/MandatoryIconField';
import ComboBox from 'Components/ComboBox/ComboBox';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import "./NewEmployesDaysStyle.css";


const NewEmployesDays = ({
    onUpdateShowNewEmployesDaysPanel,
    showNewEmployesDaysPanel,
    productionDaysIdSelecteds,
    onUpdateResetEmployeesDay
}) => {
    const [dtStart, setDtStart] = useState(null)
    const [dtEnd, setDtEnd] = useState(null)
    const [generateAvailableHours, setGenerateAvailableHours] = useState('N')

    const [productionEmployeesList, setNewEmployesDaysList] = useState(null)
    const [loadingNewEmployesDaysPanel, setLoadingNewEmployesDaysPanel] = useState(null);

    const [employeeDayId, setEmployeeDayId] = useState(null)
    const [employeeId, setEmployeeId] = useState(null)
    const [sectorIdSelected, setSectorIdSelected] = useState(null)
    const [sectors, setSectors] = useState([]);
    const [groupIdSelected, setGroupIdSelected] = useState(null)
    const [groups, setGroups] = useState([]);
    const [productionEmployeesIdsSelecteds, setProductionEmployeesIdsSelecteds] = useState([])
    const attributeList = [
        { name: "id", value: employeeDayId, setter: setEmployeeDayId, allowsMultipleRecordsSelected: true },
        { name: "employeeId", value: employeeId, setter: setEmployeeId }
    ];
    const sectorOptions = OptionsDataByAttributePath(sectors, ['description'], null, true)
    const groupOptions = OptionsDataByAttributePath(groups, ['description'], null, true)

    useEffect(() => {
        ResetVariables.resetVariables(attributeList);
        setDtStart(null)
        setDtEnd(null)
        setGenerateAvailableHours('N')
        setSectorIdSelected(null)
        setGroupIdSelected(null)
        // O painel fica montado mesmo fechado: só busca ao abrir (antes buscava também ao montar e ao fechar)
        if (!showNewEmployesDaysPanel) {
            return;
        }
        if (productionDaysIdSelecteds && productionDaysIdSelecteds.length === 1) {
            getProductionRecords(productionDaysIdSelecteds[0], null, null)
        } else {
            getProductionRecords(null, null)
        }
    }, [showNewEmployesDaysPanel])

    useEffect(() => {
        setProductionEmployeesIdsSelecteds([])
    }, [sectorIdSelected])

    useEffect(() => {
        const fetchData = async () => {
            const sectors = await ExecuteAxios.api('get', '/sector');
            setSectors(sectors);
        };

        fetchData();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            const group = await ExecuteAxios.api('get', '/employee-group/lookup/');
            setGroups(group);
        };

        fetchData();
    }, []);

    useEffect(() => {
        if (productionDaysIdSelecteds && productionDaysIdSelecteds.length === 1) {
            getProductionRecords(productionDaysIdSelecteds[0], sectorIdSelected, groupIdSelected)
        }
    }, [sectorIdSelected, groupIdSelected])


    useEffect(() => {
        if (generateAvailableHours === 'S') {
            setDtStart(null)
            setDtEnd(null)
        }
    }, [generateAvailableHours])

    async function getProductionRecords(productionDaysIdSelected, sectorIdSelected, groupIdSelected) {
        try {
            setLoadingNewEmployesDaysPanel(true)
            const parameters = { productionDayId: productionDaysIdSelected, sectorId: sectorIdSelected, employeeGroupId: groupIdSelected }
            const productionEmployeesList = await ExecuteAxios.api('get', `/employee-day/get-employees-list-with-available-minutes/`, { params: parameters });
            setNewEmployesDaysList(productionEmployeesList);
        } finally {
            setLoadingNewEmployesDaysPanel(false)
        }

    }

    const detailAtributesStyle = {
        display: 'flex',
        flexDirection: 'column',
        margin: '10px 10px 5px 10px',
        width: '200px'
    };

    const panelListStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%'
    };

    const styleButtonsMonth = {
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100% - 56px)',
        width: '100%'
    }

    async function postFunction() {
        try {
            setLoadingNewEmployesDaysPanel(true)
            const sucess = await ExecuteAxios.api('post', `/employee-day/`, {
                employeesId: productionEmployeesIdsSelecteds,
                productionDayId: productionDaysIdSelecteds[0],
                startTime: LocalTimeFromInstant.getLocalTimeFromInstant(dtStart),
                endTime: LocalTimeFromInstant.getLocalTimeFromInstant(dtEnd),
                generateAvailableHours: generateAvailableHours
            });

            if (sucess) {
                setProductionEmployeesIdsSelecteds([])
                setLoadingNewEmployesDaysPanel(false)
                onUpdateShowNewEmployesDaysPanel(false)
                ResetVariables.resetVariables(attributeList);
                setDtStart(null)
                setDtEnd(null)
                setGenerateAvailableHours('N')
                onUpdateResetEmployeesDay(true)
            }
            return sucess
        } finally {
            setLoadingNewEmployesDaysPanel(false)
        }
    }

    const handleCheckboxChangeGenerateAvailableHours = (value) => {
        if (value) {
            setGenerateAvailableHours(value === 'S' ? 'N' : 'S')
        }
    };

    function closeNewEmployesPanel() {
        onUpdateShowNewEmployesDaysPanel(false)
        ResetVariables.resetVariables(attributeList);
        setDtStart(null)
        setDtEnd(null)
        setGenerateAvailableHours('N')
    }

    return (
        <MiddlePanel isVisible={showNewEmployesDaysPanel}>
            <Panel style={{
                width: '870px',
                height: '700px',
                borderRadius: '10px',
                backgroundColor: '#f5f5f5;',
                border: '1px solid #ccc',
                boxShadow: '0px 0px 10px rgba(0, 0, 0, 30%)'
            }}>
                <div style={{ display: 'flex', flexDirection: 'row', height: '100%' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '30%' }}>
                        <span style={{
                            fontSize: '1em',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            display: 'flex',
                            minHeight: '56px',
                            maxHeight: '56px',
                            marginLeft: '10px',
                            fontSize: '1.2em',
                            alignItems: 'center',
                            whiteSpace: 'nowrap'
                        }}>
                            Filtros
                        </span>
                        <div style={detailAtributesStyle}>
                            <label>Setor</label>
                            <ComboBox setAttribute={setSectorIdSelected}
                                optionsData={sectorOptions}
                                value={sectorIdSelected}
                                defaultValue={sectorIdSelected}
                            />
                        </div>

                        <div style={detailAtributesStyle}>
                            <label>Grupo</label>
                            <ComboBox setAttribute={setGroupIdSelected}
                                optionsData={groupOptions}
                                value={groupIdSelected}
                                defaultValue={groupIdSelected}
                            />
                        </div>

                        <div style={detailAtributesStyle}>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <label>Horário início</label>
                                {generateAvailableHours === 'N' && <MandatoryIconField />}
                            </div>

                            <ReactDataPickerComp
                                selected={dtStart}
                                onChange={(date) => { setDtStart(date) }}
                                wrapperClassName={'width-full'}
                                className='validate-attribute width-full cursor-pointer'
                                readOnly={generateAvailableHours === 'S'}
                                disabled={generateAvailableHours === 'S'}
                                dateFormat={'HH:mm'}
                                timeFormat={'HH:mm'}
                                showTimeSelect={true}
                                showTimeSelectOnly={true}
                                setter={setDtStart}
                            />
                        </div>

                        <div style={detailAtributesStyle}>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <label>Horário fim</label>
                                {generateAvailableHours === 'N' && <MandatoryIconField />}
                            </div>

                            <ReactDataPickerComp
                                selected={dtEnd}
                                onChange={(date) => { setDtEnd(date) }}
                                wrapperClassName={'width-full'}
                                className='validate-attribute width-full cursor-pointer'
                                readOnly={generateAvailableHours === 'S'}
                                disabled={generateAvailableHours === 'S'}
                                dateFormat={'HH:mm'}
                                timeFormat={'HH:mm'}
                                showTimeSelect={true}
                                showTimeSelectOnly={true}
                                setter={setDtEnd}
                            />
                        </div>
                        <div style={detailAtributesStyle}>
                            <label>Gerar horários disponíveis</label>
                            <InputField
                                setAttribute={() => { handleCheckboxChangeGenerateAvailableHours(generateAvailableHours) }}
                                value={generateAvailableHours}
                                checked={generateAvailableHours === 'S'}
                                type="checkbox"
                                style={{ cursor: 'pointer' }}
                            />
                        </div>

                        <div style={detailAtributesStyle}>
                            <label>Quantidade colaboradores:</label>
                            <InputField
                                value={productionEmployeesIdsSelecteds.length}
                                readOnly={true}
                                disabled={true}
                            />
                        </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '70%' }}>
                        <Panel titlePage={'Adicionar colaboradores produção'}
                            style={panelListStyle}
                            canViewCRUD={true}
                            postFunction={postFunction}
                            canSaveAfterNewRecord={(generateAvailableHours === 'S' || (dtStart && dtEnd))
                                && productionEmployeesIdsSelecteds && productionEmployeesIdsSelecteds.length > 0}
                            cancelFunction={() => { closeNewEmployesPanel() }}
                            canNewRecord={true}
                            enableDelete={true}
                            canDelete={true}
                            cancelNameButton='Fechar'
                            recordsSelected={[]}
                            inserting={true}>
                            <Panel style={styleButtonsMonth}>
                                <LoadingIndicator loaded={!loadingNewEmployesDaysPanel}>
                                    <div className='newEmployesDays' style={{ height: '100%' }}>
                                        <PanelListDefault
                                            onUpdateIdSelected={setProductionEmployeesIdsSelecteds}
                                            idsSelected={productionEmployeesIdsSelecteds}
                                            data={productionEmployeesList}
                                            attributeList={attributeList}
                                        />
                                    </div>
                                </LoadingIndicator>
                            </Panel>
                        </Panel>
                    </div>
                </div>

            </Panel>
        </MiddlePanel >
    );
}

export default NewEmployesDays;
